import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import PageCreateEditForm from './Components/PageCreateEditForm';
import PageApi from './PageApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: PageCreateEditForm,
                getCreate: PageApi.create,
                defaults: {contentBlocks:[]},
                successMessage: "Page Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}